export default "__VITE_ASSET__JaVa92Ef__"